/* eslint-disable no-console */
import { hasDeviceEventData } from './device-event.helper';
import env from '../../source/helpers/env';

export const isDevelopmentEnv = env.ENVIRONMENT === 'development' || false;

const logMainInfo = (event, color) => {
    if (hasDeviceEventData(event)) {
        const finalColor = `color:${color}`;

        console.log(`%cID:            ${event.data.assetViewerItem.assetId}`, finalColor);
        console.log(`%cname:          ${event.data.assetViewerItem.displayName}`, finalColor);
        console.log(`%cdeviceEventId: ${event.deviceEvent.id}`, finalColor);
    }
};

export const logStart = event => {
    if (isDevelopmentEnv && env.deviceEventLoggingEnabled) {
        console.group();
        console.log('%c🏁 startDeviceEvent', 'font-weight:800;color:#13ff11');
        logMainInfo(event, '#13ff11');
        console.groupEnd();
    }
};

export const logUpdate = event => {
    if (isDevelopmentEnv && env.deviceEventLoggingEnabled) {
        console.group();
        console.log('%c🔄 updateDeviceEvent', 'font-weight:800;color:skyblue');
        logMainInfo(event, 'skyblue');
        console.groupEnd();
    }
};

export const logStop = event => {
    if (isDevelopmentEnv && env.deviceEventLoggingEnabled) {
        console.group();
        console.log('%c🛑 stopDeviceEvent', 'font-weight:800;color:#ff2929');
        logMainInfo(event, '#ff2929');
        console.groupEnd();
    }
};

export const warnDeviceEventLogging = () => {
    isDevelopmentEnv && env.deviceEventLoggingEnabled
        ? console.info(
              'ℹ️ 🟢 Device event logging is %cenabled%c. Toggle at %csource/helpers/env.js.',
              'font-weight:800;color:#15ff00',
              'font-weight:100;color:white',
              'font-weight:800;color:gold'
          )
        : console.info(
              'ℹ️ 🔴 Device event logging is %cdisabled%c. Toggle at %csource/helpers/env.js.',
              'font-weight:800;color:red',
              'font-weight:100;color:white',
              'font-weight:800;color:gold'
          );
};
